// extracted by mini-css-extract-plugin
export default {"downloadForm":"downloadreportmodal_downloadForm__n2+k3"};